import classnames from "classnames";
import React, { memo } from "react";

import { NAVIGATION_PATHS } from "./Navigation.constants";
import sidebarHelp from "assets/images/sidebar-help.svg";
import { checkRoleOnPermission } from "utils";
import { useOutletContext } from "react-router";
import { IOutletAuth } from "types";
import config from "config";
import { MenuGroupDivider } from "./components";

export interface IProps extends React.HTMLProps<HTMLDivElement> {
  classNames?: { items?: string | undefined };
  showNavigation: boolean;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
}

function Navigation({
  className,
  classNames,
  showNavigation,
  onMouseEnter,
  onMouseLeave,
  ...rest
}: IProps) {
  const context = useOutletContext<IOutletAuth>();
  return (
    <nav
      className={classnames(
        "flex navigation-bar bg-primary h-full duration-500 transition-all",
        className,
        {
          "transform -translate-x-full innerViewportSpecific:transform-none":
            showNavigation,
        }
      )}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      {...rest}
    >
      <div className={classnames("overflow-y-auto")}>
        <ul className={classnames("grid")}>
          {NAVIGATION_PATHS.map(({ groupHeader, paths, groupRole }, index) => {
            const GroupHeaderComponent = groupHeader?.component;

            if (
              groupRole &&
              !checkRoleOnPermission({
                roles: context.roles,
                requiredRole: groupRole,
              })
            ) {
              return null;
            }
            return (
              <div key={"nav" + index}>
                {showNavigation && groupHeader && (
                  <GroupHeaderComponent {...groupHeader.props} />
                )}

                {!showNavigation && groupHeader && <MenuGroupDivider />}

                {paths
                  .filter(({ moduleName }) =>
                    config.MODULES.includes(moduleName)
                  )
                  .map(({ children, role, ...rest }, i) => {
                    if (
                      role &&
                      !checkRoleOnPermission({
                        roles: context.roles,
                        requiredRole: role,
                      })
                    ) {
                      return null;
                    }
                    return (
                      <React.Fragment key={rest.to}>
                        <div key={i}>
                          {React.cloneElement(children, {
                            className: classnames(
                              "overflow-hidden duration-250 innerViewportSpecific:duration-500 transition-width w-[200px]",
                              {
                                "innerViewportSpecific:w-[64px]":
                                  !showNavigation,
                              }
                            ),
                            ...rest,
                            showNavigation,
                          })}
                        </div>
                      </React.Fragment>
                    );
                  })}
              </div>
            );
          })}
        </ul>
        <div className="  justify-start pl-5 mt-10 hidden">
          <img alt="help" src={sidebarHelp} />
        </div>
      </div>
    </nav>
  );
}

export default memo(Navigation);
